import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, Loader2 } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("checking");
  const [attempts, setAttempts] = useState(0);
  const sessionId = params.get("session_id");
  const orderId = params.get("order_id");

  useEffect(() => {
    if (!sessionId) return;
    let cancelled = false;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (cancelled) return;
        if (data.payment_status === "paid") setStatus("paid");
        else if (attempts >= 8) setStatus("pending");
        else setAttempts((a) => a + 1);
      } catch {
        if (attempts >= 8) setStatus("error"); else setAttempts((a) => a + 1);
      }
    };
    const t = setInterval(poll, 2000);
    poll();
    return () => { cancelled = true; clearInterval(t); };
    // eslint-disable-next-line
  }, [sessionId, attempts]);

  return (
    <div className="max-w-md mx-auto px-5 py-16 text-center pb-32">
      <div className="mx-auto w-24 h-24 rounded-full bg-eatup-green/10 flex items-center justify-center">
        {status === "paid" ? (
          <CheckCircle2 className="w-14 h-14 text-eatup-green" />
        ) : (
          <Loader2 className="w-14 h-14 text-eatup-green animate-spin" />
        )}
      </div>
      <h1 className="mt-6 font-display text-3xl font-bold">
        {status === "paid" ? "Payment received!" : "Confirming payment…"}
      </h1>
      <p className="mt-2 text-neutral-500">
        {status === "paid"
          ? "Your food is being prepared. We'll take you to live tracking."
          : "Hang tight — this usually takes a couple of seconds."}
      </p>
      {status === "paid" && (
        <button
          data-testid="track-order-btn"
          onClick={() => navigate(`/track/${orderId}`)}
          className="mt-8 w-full inline-flex items-center justify-center gap-2 rounded-full bg-eatup-green hover:bg-eatup-green-dark text-white font-display font-black uppercase tracking-widest text-sm px-6 py-4 shadow-lg transition active:scale-[0.98]"
        >
          <span className="relative flex w-2 h-2">
            <span className="absolute inset-0 rounded-full bg-white/60 animate-ping" />
            <span className="relative w-2 h-2 rounded-full bg-white" />
          </span>
          Track your food — live map
        </button>
      )}
      {status === "pending" && (
        <button onClick={() => navigate("/orders")} className="btn-primary mt-6" data-testid="see-orders-btn">See orders</button>
      )}
    </div>
  );
}
